import * as R from 'ramda'
import { useSelector } from 'react-redux'
import { useOpenedRoomId } from '$logic/opened-room'
import { PendingMessage } from './types'
import { RootState } from '$setup/redux'

const pendingMessagesView = (state: RootState) =>
  state.main.pendingMessages as PendingMessage[]

export function usePendingMessages() {
  return useSelector(pendingMessagesView)
}

export function useOpenedRoomPendingMessages() {
  const roomId = useOpenedRoomId()
  return useRoomPendingMessagesById(roomId)
}

const comparePendingMessages = (
  current: PendingMessage[],
  next: PendingMessage[],
) =>
  current.length === next.length &&
  current.every((msg, i) => msg.id === next[i].id)

const memoizedSelector = R.memoizeWith(
  roomId => roomId as string,
  roomId => (state: RootState) =>
    (state.main.pendingMessages as PendingMessage[]).filter(
      msg => msg.roomId === roomId,
    ),
)

export function useRoomPendingMessagesById(roomId: string = '') {
  return useSelector(memoizedSelector(roomId), comparePendingMessages)
}
